import { fetchLocation } from "../../api";

const state = {
  countries: [],
  states: [],
  cities: [],
  addresses: {
    country: "",
    state: "",
    city: "",
  },
};

const getters = {
  countries: state => state.countries,
  states: state => state.states,
  cities: state => state.cities,
  addresses: state => state.addresses,
};

const actions = {
  async getLocation(_, locationType) {
    const response = await fetchLocation(locationType);
    return response.data;
  },
  async getCountries({ commit, dispatch }) {
    await dispatch("getLocation", "paises").then(response => {
      commit("setCountries", response);
      commit(
        "setCountry",
        response?.result.find(
          country => country.id === "9e1bf96ca2754ee6596f26fd6e6b5cc2"
        )
      );
    });
  },
  async getStates({ commit, dispatch }, countryId) {
    await dispatch("getLocation", `estados/${countryId}`).then(response => {
      commit("setStates", response);
    });
  },
  async getCities({ commit, dispatch }, stateId) {
    await dispatch("getLocation", `cidades/${stateId}`).then(response => {
      commit("setCities", response);
    });
  },
  async populateLocation({ dispatch, getters, commit }) {
    await dispatch("getCountries");
    const filteredCountry = getters.countries?.result.find(
      country => country.dsc === getters.getEventBasicData.country
    );
    commit("setCountry", filteredCountry);
    if (filteredCountry) {
      await dispatch("getStates", filteredCountry?.id);
      const filteredState = getters.states?.result.find(
        state => state.iso_full === getters.getEventBasicData.state
      );
      commit("setState", filteredState);

      if (filteredState) {
        await dispatch("getCities", filteredState?.id);
        const filteredCity = getters.cities?.result.find(
          city => city.dsc === getters.getEventBasicData.city
        );
        commit("setCity", filteredCity);
      }
    }
  },
  clearLocations({ commit }) {
    commit("setCountry", null);
    commit("setState", null);
    commit("setCity", null);
  },
  watchCountry({ dispatch, state, commit }) {
    if (state.addresses.country) {
      commit("setState", null);
      commit("setCity", null);
      dispatch("getStates", state.addresses.country.id);
    }
  },
  watchState({ dispatch, state, commit }) {
    if (state.addresses.state) {
      commit("setCity", null);
      dispatch("getCities", state.addresses.state.id);
    }
  },
};

const mutations = {
  setCountries: (state, countries) => (state.countries = countries),
  setStates: (state, states) => (state.states = states),
  setCities: (state, cities) => (state.cities = cities),

  setAddresses: (state, address) => (state.addresses = address),

  setCountry: (state, country) => (state.addresses.country = country),
  setState: (state, selectedState) => (state.addresses.state = selectedState),
  setCity: (state, city) => (state.addresses.city = city),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
